import { render, staticRenderFns } from "./IlmoittautuminenParticipant.vue?vue&type=template&id=3350f836&scoped=true"
import script from "./IlmoittautuminenParticipant.vue?vue&type=script&lang=js"
export * from "./IlmoittautuminenParticipant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3350f836",
  null
  
)

export default component.exports